import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, IconButton, Chip, Box } from '@mui/material';
import React from 'react'
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../../constants/colors';
import { useTranslation } from 'react-i18next';
import StatusChip from '../../../../components/StatusChip';
import { PromotionModel } from '../../../../models/promotion';
import { numberFormat } from '../../../../utils/nunberFormat';
import { EN_ACCEPT_LANGUAGE } from '../../../../constants/acceptLanguageApi';
import TableSearchNotFound from '../../../../components/tableSearchNotFound';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

interface Props {
    rows: PromotionModel[]
    currentPage: number
    handleOpenMenu: Function
    isSearchNotFound: boolean
    searchValue: string
}

const TableRDComponent = ({ rows, currentPage, handleOpenMenu, isSearchNotFound, searchValue }: Props) => {
    const { t, i18n } = useTranslation('global')

    return (
        <Box sx={{ overflow: 'hidden' }}>
            <TableContainer
                sx={{
                    mb: 1,
                }}
            >
                <Table>
                    <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                        <TableRow>
                            <TableCell sx={{ minWidth: 70 }}>{t("promotion_page.No")}</TableCell>
                            <TableCell sx={{ minWidth: 150 }}>{t("promotion_page.Promotion name")}</TableCell>
                            <TableCell sx={{ minWidth: 250 }}>{t("promotion_page.Buy Product")}</TableCell>
                            <TableCell sx={{ minWidth: 120 }}>{t("promotion_page.Item Code")}</TableCell>
                            <TableCell sx={{ minWidth: 150 }}>{t("promotion_page.Total Buy Price")}</TableCell>
                            <TableCell sx={{ minWidth: 250 }}>{t("promotion_page.Get Product RD")}</TableCell>
                            <TableCell sx={{ minWidth: 120 }}>{t("promotion_page.Item Code")}</TableCell>
                            <TableCell sx={{ minWidth: 120 }}>{t("promotion_page.Start Date")}</TableCell>
                            <TableCell sx={{ minWidth: 120 }}>{t("promotion_page.End Date")}</TableCell>
                            <TableCell sx={{ minWidth: 100 }}>{t("promotion_page.Status")}</TableCell>
                            <TableCell sx={{ minWidth: 150 }}>{t("Branch")}</TableCell>
                            <TableCell sx={{ minWidth: 70 }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((item: PromotionModel, index: number) => {
                            const { id, promotionName, startDate, endDate, isActiveStatus, buyProduct, buyByPrice, getProduct } = item;
                            return (
                                <TableRow hover key={id}>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        {numberFormat((index + 1) + (10 * (currentPage - 1)))}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        {promotionName}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                        <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                                            {buyProduct.map((item, index) => (
                                                <li key={index} style={{ backgroundColor: '#36B37E29', padding: '10px', marginBottom: '5px', borderRadius: '5px' }}>
                                                    {i18n.language === EN_ACCEPT_LANGUAGE ? item.productNameEn : item.productNameLa}
                                                </li>
                                            ))}
                                        </ul>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                        <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                                            {buyProduct.map((item, index) => (
                                                <li key={index} style={{ backgroundColor: '#36B37E29', padding: '10px', marginBottom: '5px', borderRadius: '5px' }}>
                                                    {item?.itemcode}
                                                </li>
                                            ))}
                                        </ul>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                        {numberFormat(buyByPrice)} {t("Kip")}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                        <span>{i18n.language === EN_ACCEPT_LANGUAGE ? getProduct?.productNameEn : getProduct?.productNameLa}</span>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                        {getProduct?.itemcode}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        {startDate}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        {endDate}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        <StatusChip status={isActiveStatus} />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none  ' }}>
                                        <Chip
                                            style={{
                                                backgroundColor: '#36B37E29',
                                                color: '#1B806A',
                                                borderRadius: '5px'
                                            }}
                                            label={i18n.language === EN_ACCEPT_LANGUAGE ? item?.branch?.nameEn : item?.branch?.nameLa}
                                        />
                                    </TableCell>
                                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                        <IconButton size="large" color="inherit" onClick={(e: any) => handleOpenMenu(e, id)}>
                                            <MoreHorizIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        }
                    </TableBody>
                    {isSearchNotFound && (
                        <TableSearchNotFound searchValue={searchValue} colSpan={12} />
                    )}
                </Table>
            </TableContainer>
        </Box>
    )
}

export default TableRDComponent